export default __webpack_public_path__ + "static/media/Arrow Down.aeda611d.svg";